import { useFcmToken } from '../../notifications/hooks/useFcmToken';
import { useAppPresence } from '../../notifications/hooks/useAppPresence';

// The push token and the presence heartbeat belong to the signed-in session,
// not to a navigation chrome. They used to live in Header (and MobileShell),
// which remount whenever the window crosses 900 px and then re-ran the
// service-worker registration and getToken. Layout renders this once, inside
// the legal gate, so a user who has not accepted the documents gets neither.
export function PushAndPresence() {
    const { currentToken } = useFcmToken();
    useAppPresence(currentToken);
    return null;
}
